module.exports = __webpack_public_path__ + "img/icon-user.a7922517.svg";